module.exports = __webpack_public_path__ + "img/LandschaftIX.e113251b.jpg";